import { Component } from "inferno";
import { LaunchPadItem } from '../../utils/types';

type Props = { item: LaunchPadItem, showChannelDetails: Function, spacing: number }

export class ChannelEntry extends Component<Props, any> {

	item: LaunchPadItem;

	componentWillMount () {
		this.item = this.props.item;
	}

	render() {
		const css = {
			"margin": "auto",
			"padding": this.props.spacing + "rem",
			"cursor": "pointer"
		};
		return (
			<div key={this.item.type} style={css} onClick={() => {
				this.props.showChannelDetails(this.item);
			}}>
				{
				typeof this.item.icon === "object" && this.item.icon.base64
						? <div className="lpChannelIcon lpChannelIconShadow"><img src={this.item.icon.base64} /></div>
						: <div className="lpChannelIcon lpChannelIconShadow" dangerouslySetInnerHTML={{ __html: this.item.icon as string }} ></div>
				}
			</div>
		);
	}
}